/* Teacher Carmelita 2026 · interazioni leggere */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.tc-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  var NAMES = ['', 'bianco', 'rosso', 'verde chiaro', 'rosa', 'giallo', 'verde scuro', 'nero', 'marrone', 'celeste'];

  function initTry(root) {
    (root || document).querySelectorAll('[data-tc-try]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var state = { t: 3, u: 7 };
      var out = box.querySelector('[data-tc-try-num]');
      var txt = box.querySelector('[data-tc-try-text]');
      function render() {
        out.innerHTML = '<span class="tc-n' + state.t + '">' + state.t + '</span><span class="tc-n' + state.u + '">' + state.u + '</span>';
        txt.textContent = 'Il ' + state.t + ' delle decine è ' + NAMES[state.t] + ', il ' + state.u + ' delle unità è ' + NAMES[state.u] + '. Il bambino non deve ricordare ' + (state.t * 10 + state.u) + ': vede due colori che conosce già.';
        box.querySelectorAll('[data-tc-t]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.tcT === state.t)); });
        box.querySelectorAll('[data-tc-u]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.tcU === state.u)); });
      }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        if (b.dataset.tcT) state.t = +b.dataset.tcT;
        if (b.dataset.tcU) state.u = +b.dataset.tcU;
        render();
      });
      render();
    });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-tc-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', String(on));
            var p = wrap.querySelector('#' + t.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
            if (!on && p) p.querySelectorAll('video').forEach(function (v) { v.pause(); });
          });
        });
      });
    });
  }

  function initAll(root) { initReveal(root); initTry(root); initTabs(root); }

  ready(function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
